// MOTORE GLOBALE DELLA WISHLIST
window.toggleProductWishlistItem = window.toggleProductWishlistItem || function(handle, title, price, image, btnElement) {
  let wishlist = JSON.parse(localStorage.getItem('koji_wishlist_data')) || [];
  const index = wishlist.findIndex(item => item.handle === handle);

  if (index > -1) {
    wishlist.splice(index, 1);
    btnElement.classList.remove('is-active');
  } else {
    wishlist.push({ handle, title, price, image });
    btnElement.classList.add('is-active');
    if (navigator.vibrate) navigator.vibrate(50);
  }

  localStorage.setItem('koji_wishlist_data', JSON.stringify(wishlist));

  const headerBadges = document.querySelectorAll('.koji-wishlist-badge');
  headerBadges.forEach(badge => {
    badge.textContent = wishlist.length;
    badge.classList.toggle('is-active', wishlist.length > 0);
  });
};

document.addEventListener('DOMContentLoaded', function() {
  const recommendationsWrappers = document.querySelectorAll('.koji-recommendations-wrapper');
  
  recommendationsWrappers.forEach(wrapper => {
    const url = wrapper.dataset.url;
    
    if (url) {
      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendationsContent = html.querySelector('.koji-recommendations-wrapper');

          if (recommendationsContent && recommendationsContent.innerHTML.trim().length > 0) {
            wrapper.innerHTML = recommendationsContent.innerHTML;
            
            initRecommendationsScroll(wrapper);
            initRecommendationsCards(wrapper);
          }
        })
        .catch(e => {
          console.error('Errore caricamento prodotti consigliati:', e);
        });
    } else {
      initRecommendationsScroll(wrapper);
      initRecommendationsCards(wrapper);
    }
  });

  // Funzione per lo scroll con le frecce (Desktop)
  function initRecommendationsScroll(wrapper) {
    const track = wrapper.querySelector('.koji-col-track');
    const prevBtn = wrapper.querySelector('.koji-col-prev');
    const nextBtn = wrapper.querySelector('.koji-col-next');

    if (track && prevBtn && nextBtn) {
      const scrollAmount = () => {
        const item = track.querySelector('.koji-col-item');
        return item ? item.offsetWidth + parseFloat(window.getComputedStyle(track).gap || 24) : 300;
      };
      nextBtn.addEventListener('click', () => track.scrollBy({ left: scrollAmount() * 2, behavior: 'smooth' }));
      prevBtn.addEventListener('click', () => track.scrollBy({ left: -(scrollAmount() * 2), behavior: 'smooth' }));
    }
  }

  // Funzione per i bottoni Master (Koji Add to Cart e Wishlist)
  function initRecommendationsCards(wrapper) {
    
    // Aggiorna lo stato dei cuoricini appena iniettati a schermo
    function updateWishlistHearts() {
      const wishlist = JSON.parse(localStorage.getItem('koji_wishlist_data')) || [];
      wrapper.querySelectorAll('.koji-card-wishlist-btn').forEach(btn => {
        const handle = btn.dataset.handle;
        if(wishlist.some(item => item.handle === handle)) {
          btn.classList.add('is-active');
        } else {
          btn.classList.remove('is-active');
        }
      });
    }
    updateWishlistHearts();

    function updateHeaderCartBadge() {
      fetch('/cart.js')
        .then(resp => resp.json())
        .then(cartData => {
          const headerBadge = document.getElementById('koji-cart-badge');
          if (headerBadge) {
            headerBadge.textContent = cartData.item_count;
            if (cartData.item_count > 0) { headerBadge.classList.add('is-active'); } 
            else { headerBadge.classList.remove('is-active'); }
          }
        });
    }

    const productCards = wrapper.querySelectorAll('[data-koji-card]');

    productCards.forEach(card => {
      const addBtn = card.querySelector('.koji-js-add-btn');
      const btnText = card.querySelector('.koji-drawer-text');
      const variantId = card.getAttribute('data-variant-id');
      const qtyControls = card.querySelector('.koji-drawer-qty-controls');
      
      const maxQtyAttr = card.getAttribute('data-max-qty');
      const maxQty = maxQtyAttr ? parseInt(maxQtyAttr, 10) : 9999;
      
      if (!addBtn || !variantId || !qtyControls) return;

      const qtyNumDisplay = qtyControls.querySelector('.koji-d-qty-num');
      const btnMinus = qtyControls.querySelector('.koji-d-qty-minus');
      const btnPlus = qtyControls.querySelector('.koji-d-qty-plus');

      let currentQtyInCart = 0; 
      const originalBtnText = btnText.textContent; 
      let debounceTimer; 

      const updatePlusBtnUI = () => {
        if (currentQtyInCart >= maxQty) { btnPlus.classList.add('is-disabled'); } 
        else { btnPlus.classList.remove('is-disabled'); }
      };

      const executeCartUpdate = (targetQuantity) => {
        const isRemovingCompletely = targetQuantity === 0;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 'id': variantId, 'quantity': targetQuantity })
        })
        .then(response => response.json())
        .then(data => {
          updateHeaderCartBadge();
          window.dispatchEvent(new Event('cart:updated'));
          if (isRemovingCompletely) {
            card.classList.remove('is-qty-mode');
            btnText.textContent = originalBtnText; 
            updatePlusBtnUI();
          }
        });
      };

      const updateCartDebounced = (targetQuantity) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => { executeCartUpdate(targetQuantity); }, 500);
      };

      addBtn.addEventListener('click', function(e) {
        if (e.target.closest('.koji-drawer-qty-controls')) return;
        if (card.classList.contains('is-qty-mode')) return;
        
        e.preventDefault(); e.stopPropagation(); 
        if (navigator.vibrate) navigator.vibrate(40);
        this.blur(); 

        this.classList.add('is-loading');
        currentQtyInCart = 1;
        updatePlusBtnUI();
        
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 'items': [{ 'id': variantId, 'quantity': 1 }] })
        })
        .then(response => response.json())
        .then(data => {
          this.classList.remove('is-loading');
          
          card.classList.add('is-success');
          btnText.textContent = 'PRESO!';
          if (qtyNumDisplay) qtyNumDisplay.textContent = currentQtyInCart;
          
          updateHeaderCartBadge();
          window.dispatchEvent(new Event('cart:updated'));

          setTimeout(() => {
            card.classList.remove('is-success');
            card.classList.add('is-qty-mode');
          }, 800); 

        })
        .catch((error) => {
          console.error('Error Add-to-Cart Koji:', error);
          this.classList.remove('is-loading');
        });
      });

      if (btnPlus && btnMinus) {
        btnPlus.addEventListener('click', (e) => {
          e.preventDefault(); e.stopPropagation();
          if (currentQtyInCart >= maxQty) { if (navigator.vibrate) navigator.vibrate([20, 50, 20]); return; }
          if (navigator.vibrate) navigator.vibrate(15);
          
          currentQtyInCart++;
          if (qtyNumDisplay) {
             qtyNumDisplay.textContent = currentQtyInCart;
             qtyNumDisplay.style.transform = 'scale(1.3)';
             setTimeout(()=> qtyNumDisplay.style.transform = 'scale(1)', 150);
          }
          updatePlusBtnUI();
          updateCartDebounced(currentQtyInCart); 
        });

        btnMinus.addEventListener('click', (e) => {
          e.preventDefault(); e.stopPropagation();
          if (navigator.vibrate) navigator.vibrate(15);
          
          if (currentQtyInCart > 0) {
            currentQtyInCart--;
            
            if (currentQtyInCart > 0) { 
              if (qtyNumDisplay) {
                 qtyNumDisplay.textContent = currentQtyInCart;
                 qtyNumDisplay.style.transform = 'scale(0.7)';
                 setTimeout(()=> qtyNumDisplay.style.transform = 'scale(1)', 150);
              }
            } else { 
              if (qtyNumDisplay) qtyNumDisplay.textContent = "0"; 
            }
            
            updatePlusBtnUI();
            updateCartDebounced(currentQtyInCart);
          }
        });
      }
    });
  }
});